import React from 'react';
import { useAuth } from '../services/auth';

interface Props {
  permission?: string;
  anyOf?: string[];
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Conditionally renders its children based on the current user's permissions.
 * Mirrors the workspace's Can component.
 */
export const Can: React.FC<Props> = ({ permission, anyOf, fallback = null, children }) => {
  const { hasPermission, hasAnyPermission } = useAuth();
  const allowed = permission
    ? hasPermission(permission)
    : anyOf && anyOf.length > 0
      ? hasAnyPermission(...anyOf)
      : true;
  return allowed ? <>{children}</> : <>{fallback}</>;
};
